import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

export const uploadCustomersBatchFile = async (file: any) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const url = "/v3/customer/batch";
    const response = await axiosClient.post(url, formData);
    const resData = response?.data;
    if (resData?.statusCode === 200 && resData?.success) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getCustomersBatchFailures = async (jobId: string) => {
  try {
    const url = `/v3/customer/batch/${jobId}/failures`;
    const response = await axiosClient.get(url);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getCustomersBatchList = async ({
  limit = 100,
  offset = 0,
}: {
  limit?: number;
  offset?: number;
}) => {
  try {
    const url = "/v3/customer/batch";
    const response = await axiosClient.get(url, {
      params: { limit, offset },
    });
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const cancelCustomersBatchJob = async (jobId: string) => {
  try {
    const url = `/v3/customer/batch/${jobId}/cancel`;
    const response = await axiosClient.post(url);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
